import { createTheme } from "@mui/material/styles";
import PoppinsBoldFont from "assets/fonts/Poppins-Bold.ttf";
import PoppinsSemiBoldFont from "assets/fonts/Poppins-SemiBold.ttf";
import PoppinsLightFont from "assets/fonts/Poppins-Light.ttf";
import PoppinsMediumFont from "assets/fonts/Poppins-Medium.ttf";
import PoppinsRegularFont from "assets/fonts/Poppins-Regular.ttf";

declare module "@mui/material/styles" {
  interface Theme {
    custom: {
      White: string;
      Black: string;
      Gray: string;
      Gray1: string;
      Gray2: string;
      Blue: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    custom?: {
      White: string;
      Black: string;
      Gray: string;
      Gray1: string;
      Gray2: string;
      Blue: string;
    };
  }
}

const CaladreCustomTheme = createTheme(
  {
    palette: {
      mode: "light",
      primary: {
        main: "#16798A",
      },
      secondary: {
        main: "rgba(22, 121, 138, 0.5)",
      },
      success: {
        main: "#7AB800",
      },
      warning: {
        main: "#E05206",
      },
      error: {
        main: "#CB0044",
      },
      info: {
        main: "#bdbdbd",
      },
    },
    typography: {
      allVariants: {
        fontFamily: "PoppinsRegular, sans-serif",
      },
      subtitle1: {
        fontFamily: "PoppinsSemiBold, sans-serif",
        fontSize: "48px",
        color: "#FFFFFF",
      },
      subtitle2: {
        fontFamily: "PoppinsSemiBold, sans-serif",
        fontSize: "32px",
      },
      h1: {
        fontFamily: "PoppinsSemiBold, sans-serif",
        fontSize: "36px",
        textTransform: "uppercase",
        color: "#000",
        // '@media (max-width:1000px)': {
        //   fontSize: '36px',
        // },
      },
      h2: {
        fontFamily: "PoppinsBold, sans-serif",
        fontSize: 28,
        color: "#000",
      },
      h3: {
        fontFamily: "PoppinsBold, sans-serif",
        fontSize: 24,
        color: "#000",
      },
      h4: {
        fontFamily: "PoppinsBold, sans-serif",
        fontSize: 26,
        color: "#000",
      },
      h5: {
        fontFamily: "PoppinsBold, sans-serif",
        fontSize: 18,
      },
      h6: {
        fontFamily: "PoppinsSemiBold, sans-serif",
        fontSize: 14,
      },
      body1: {
        fontFamily: "PoppinsRegular, sans-serif",
        fontSize: 14,
        color: "#000000",
      },
      body2: {
        fontFamily: "PoppinsRegular, sans-serif",
        fontSize: 14,
        color: "#16798A",
      },
      button: {
        fontFamily: "PoppinsBold, sans-serif",
        fontSize: "14px",
        "@media (max-width:600px)": {
          fontSize: "10px",
        },
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
        @font-face {
          font-family: 'PoppinsBold';
          src: url(${PoppinsBoldFont}) format('truetype');
        }

        @font-face {
          font-family: 'PoppinsSemiBold';
          src: url(${PoppinsSemiBoldFont}) format('truetype');
        }

        @font-face {
          font-family: 'PoppinsLight';
          src: url(${PoppinsLightFont}) format('truetype');
        }

        @font-face {
          font-family: 'PoppinsMedium';
          src: url(${PoppinsMediumFont}) format('truetype');
        }

        @font-face {
          font-family: 'PoppinsRegular';
          src: url(${PoppinsRegularFont}) format('truetype');
        }
      `,
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: "16px",
            border: "1px solid transparent",
            borderRadius: "12px",
            padding: "10px 16px",
            "&:hover": {
              border: "1px solid #16798A",
              color: "#16798A",
              backgroundColor: "#FFFFFF",
            },
            "&.MuiButton-textInfo:hover": {
              border: "none",
              color: "inherit",
              backgroundColor: "inherit",
            },
            textTransform: "initial",
          },
        },
      },
      MuiButtonGroup: {
        styleOverrides: {
          root: {
            "&.MuiButtonGroup-grouped:not(:first-of-type)": {
              borderColor: "#002B60",
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
            },
          },
          input: {
            fontSize: "14px",
            padding: "16px 14px !important",
            borderRadius: "7px",
            backgroundColor: "#E8E8E8",
            "&.MuiInputBase-root-MuiOutlinedInput-root": {
              borderColor: "transparent",
            },
          },
          notchedOutline: {
            borderColor: "transparent",
            "&:hover": {
              borderColor: "transparent",
            },
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          label: {
            fontSize: "12px",
          },
        },
      },
      MuiAvatar: {
        styleOverrides: {
          root: {
            backgroundColor: "#DFDFDF",
          },
        },
      },
    },
    // breakpoints: {
    //   values: {
    //     xs: 0,
    //     sm: 600,
    //     md: 900,
    //     lg: 1200,
    //     xl: 1400,
    //   },
    // },
  },
  {
    custom: {
      White: "#FFF",
      Black: "#000",
      Gray: "#E8E8E8",
      Gray1: "#EBEBEB",
      Gray2: "#DFDFDF",
      Blue: "#002B60",
    },
  },
);

// const CaladreTheme = responsiveFontSizes(CaladreCustomTheme);
const CaladreTheme = CaladreCustomTheme;

export default CaladreTheme;
